<template>
  <div class="p-author container">
    <div class="p-author__body">
      <div class="p-author__label">
        <h1>「{{ author }}」{{ authorLabel }}的文章列表</h1>
        <div v-if="datas !== null && datas.total" class="p-author__total">
          共發表 <span>{{ Number(datas.total).toLocaleString() }}</span> 篇文章
        </div>
      </div>
      <div v-if="datas !== null && datas.items.length > 0" class="p-author__content">
        <a
          v-for="i in datas.items"
          :key="i.path"
          :href="`${i.path}/`"
          :title="`另開視窗至${i.type === 'video' ? '影音' : ''}新聞頁`"
          class="m-card-s m-card-s--full p-author__result"
          target="_blank"
          rel="noreferrer noopener"
        >
          <div class="m-card-s__img-container">
            <div v-if="i.content_type === 'release' || i.content_type === 'sponsored'" class="e-type--bg m-card-s__type">
              <span :class="articleType(i).style" class="e-type">
                {{ articleType(i).text }}
              </span>
            </div>
            <LazyImage :src="selectImageSize(i.cover)" :alt="i.caption" class="m-card-s__img" width="258" height="135" />
            <div v-if="i.type === 'video'" class="e-video__icon-wrapper">
              <div class="e-video__icon" />
            </div>
          </div>
          <div class="m-card-s__content">
            <h3 class="m-card-s__title m-card-s__title--lg" v-html="i.title" />
            <p class="m-card-s__article m-card--mle-3 m-card--mle-m-7" v-html="i.pure_content" />
            <div class="m-card-s__footer">
              <span class="e-time">
                <img src="https://static.ctwant.com/images/dist/clock.svg" class="m-card__clock" width="14" height="14" alt="publish-icon">
                {{ i.publish_at }}
              </span>
              <span class="m-card-s__btn">
                繼續閱讀
              </span>
            </div>
          </div>
        </a>
      </div>
      <div v-else class="p-author__content">
        <p class="p-author__noItems">
          沒有查詢到「{{ author }}」{{ authorLabel }}的文章。
          <br>
          <nuxt-link to="/" title="返回首頁">
            點我返回首頁
          </nuxt-link>
        </p>
      </div>
    </div>
    <Pagination v-if="datas !== null && datas.items.length > 0" :current-page="datas.current_page" :total-page="datas.last_page" @update="pageChange" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import articleHelpers from '@/utils/articleHelpers.js'
import Pagination from '@/components/Pagination.vue'
import LazyImage from '@/components/LazyImage.vue'

export default {
  components: {
    Pagination,
    LazyImage
  },
  mixins: [articleHelpers],
  async asyncData({ $axios, route, error }) {
    const api = $axios.defaults.baseURL

    const p = {
      params: {
        page: route.query.page || 1
      }
    }
    const role = route.params.role ? route.params.role : 'editor'
    const name = route.params.name ? route.params.name.trim() : ''

    try {
      const { data } = await $axios.$get(`${api}/participants/${role}/${encodeURIComponent(name)}`, p)
      if (data.total === 0) {
        error({ statusCode: 404 })
      }
      return {
        datas: data,
        author: route.params.name.trim(),
        query: {
          role,
          name
        }
      }
    } catch (e) {
      console.error('Author', {
        code: e.response.data.code,
        message: e.response.data.message,
        method: e.response.config.method,
        url: e.response.config.url
      })
      error({ statusCode: 404 })
    }
  },
  data() {
    return {
      datas: null,
      author: '',
      query: {
        name: '',
        role: ''
      }
    }
  },
  head() {
    const hostAndNeedBackslashPath = this.HOST + (this.$route.params && this.$route.params.name ? `/author/${this.$route.params.role}/${encodeURIComponent(this.$route.params.name.trim())}/` : `${this.$route.path}/`)
    let descVal = ''
    if (this.datas !== null && this.datas.items.length > 3) {
      for (let i = 0; i < 3; i++) {
        descVal += (this.datas.items[i].title + (i !== 2 ? ', ' : ''))
      }
    } else {
      descVal = 'CTWANT為一綜合型新聞網站，由王道旺台媒體股份有限公司於2019年7月創建，涵蓋政治、財經、社會、娛樂、漂亮、生活、國際、影音等八大類別，提供獨家新聞及豐富內容，未來將企劃更多精采專題，讓您一手掌握最新資訊！'
    }
    const headObj = {
      title: this.query.name === '' ? '編輯報導相關新聞 | CTWANT' : `「${this.query.name}」相關新聞 | CTWANT`,
      meta: [
        { hid: 'description', name: 'description', content: descVal },
        { hid: 'author', name: 'author', content: this.query.name || 'CTWANT' },
        { hid: 'ogUrl', property: 'og:url', content: (this.datas !== null && this.datas.items.length > 0) ? hostAndNeedBackslashPath : `${this.HOST}/author/` },
        { hid: 'ogTitle', property: 'og:title', content: `「${this.query.name}」相關新聞 | CTWANT` },
        { hid: 'ogDescription', property: 'og:description', content: descVal }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: (this.datas !== null && this.datas.items.length > 0) ? hostAndNeedBackslashPath : `${this.HOST}/author/` }
        // { hid: 'canonical', rel: 'canonical', href: (this.datas !== null && this.datas.items.length > 0) ? hostAndNeedBackslashPath : `${this.HOST}/author/` }
      ]
    }
    // 如果 關鍵字數字大於6  or  page大於1頁
    if (this.query.name.length > 6 || this.$route.query.page) {
      headObj.meta.push({ hid: 'robots', name: 'robots', content: 'noindex, nofollow' })
    } else {
      headObj.link.push({ hid: 'canonical', rel: 'canonical', href: (this.datas !== null && this.datas.items.length > 0) ? hostAndNeedBackslashPath : `${this.HOST}/author/` })
    }
    return headObj
  },
  computed: {
    ...mapGetters([
      'HOST',
      'WIDTH_PAD',
      'screenWidth'
    ]),
    selectImageSize() {
      const sw = this.screenWidth
      return function (imageArr) {
        let imgUrl = null

        if (sw <= this.WIDTH_PAD) {
          imgUrl = imageArr.sm
        } else {
          imgUrl = imageArr.md
        }
        return imgUrl
      }
    },
    authorLabel() {
      if (this.query.role) {
        switch (this.query.role) {
          case 'author':
            return '作者'
          case 'editor':
            return '編輯'
          case 'reporter':
            return '記者'
        }
      }
      return '編輯'
    }
  },
  watchQuery: true,
  mounted() {
    const vm = this
    let isHideAd = 'N'
    let isOtherAd = 'N'
    if (this.datas !== null) {
      for (const i in this.datas.items) {
        if (i.is_hide_ad === 'Y') {
          isHideAd = 'Y'
        }
        if (i.is_hide_ad === 'Y') {
          isOtherAd = 'Y'
        }
      }
    }
    this.$nextTick(() => {
      this.$store.dispatch('ad/displayAd', {
        isHideAd,
        isOtherAd
      })
      this.$store.dispatch('ad/registerAndDisplayPopupAd', {
        isHideAd
      })
      vm.$gtm.push({
        event: 'domMounted',
        pageUrl: vm.$route.fullPath,
        pageTitle: vm.query.name === '' ? '' : `「${vm.query.name}」報導相關新聞`
      })
    })
  },
  methods: {
    searching() {
      if (this.query.name === '') {
        this.$notyf.error('查無此記者')
        return
      }
      this.$router.push({
        path: 'author',
        query: this.query
      })
    },
    pageChange(num) {
      // this.query.page = num
      // this.searching()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/pages/_author';
</style>
